import axios from "axios";
import { getDeploymentScope } from "./deploymentScope";

const normalizeBaseUrl = (value, fallback) => {
  let v = String(value || fallback || "").trim().replace(/\/+$/, "");
  if (!v) return fallback;
  if (!/^https?:\/\//i.test(v)) v = `https://${v}`;
  return v;
};

const BASE_URL = normalizeBaseUrl(
  process.env.REACT_APP_API_URL ||
    (typeof window !== "undefined" && window.__API_URL__),
  "http://localhost:3001"
);

export const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
});

let storedToken = null;
export const setAuthToken = (token) => {
  storedToken = token || null;
};

api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  const scope = getDeploymentScope();
  if (scope) config.headers["X-Deployment-Scope"] = scope;
  if (storedToken) {
    config.headers.Authorization = `Bearer ${storedToken}`;
  }
  return config;
});

export default api;
